<!--
 * @Author: wangchao wchao_sr@neusiri.com
 * @Date: 2023-09-01 09:34:24
 * @LastEditors: wangchao wchao_sr@neusiri.com
 * @LastEditTime: 2023-09-12 17:01:55
 * @FilePath: \Collection\src\views\ModuleAndLang\components\SubscribeModal.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <a-modal
    v-model:visible="subscribeModal"
    :title="subscribeTitleType ? '编辑' : '新增'"
    okText="保存"
    cancelText="取消"
    @ok="subscribeSave"
    @cancel="handleMdalClose"
  >
    <slot></slot>
    <a-form
      :model="modalData"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
      ref="subscribeFormRef"
      :rules="subscribeFormRules"
    >
      <a-form-item label="订阅场景" name="scene">
        <a-select
          ref="select"
          v-model:value="modalData.scene"
          :disabled="disabled"
        >
          <a-select-option
            v-for="item in subscribeMapList"
            :key="item.value"
            :value="item.value"
            >{{ item.label }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item label="状态">
        <a-checkbox v-model:checked="modalData.pcStatus" :disabled="disabled"
          >PC端开启订阅</a-checkbox
        >
        <a-checkbox v-model:checked="modalData.mStatus" :disabled="disabled"
          >M端开启订阅</a-checkbox
        >
      </a-form-item>
      <a-form-item label="订阅文案" name="subscriptionText">
        <a-input
          autocomplete="off"
          v-model:value="modalData.subscriptionText"
          placeholder="限制200字符"
          :maxlength="200"
        />
      </a-form-item>
      <a-form-item label="未订阅按钮" name="unsubscribedButtonText">
        <a-input
          autocomplete="off"
          v-model:value="modalData.unsubscribedButtonText"
          placeholder="限制50字符"
          :maxlength="50"
        />
      </a-form-item>
      <a-form-item label="已订阅按钮" name="subscribedButtonText">
        <a-input
          autocomplete="off"
          v-model:value="modalData.subscribedButtonText"
          placeholder="限制50字符"
          :maxlength="50"
        />
      </a-form-item>
      <a-form-item label="订阅成功文案" name="subscriptionSuccessText">
        <a-input
          autocomplete="off"
          v-model:value="modalData.subscriptionSuccessText"
          placeholder="限制50字符"
          :maxlength="50"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { toRefs, inject } from 'vue'

export default {
  setup() {
    const modalData = inject('modalData')
    // const modalData = computed(() => {
    //   const { subscribeFormState = {}, langCode = '' } = inject('initState')
    //   const { langs = [] } = subscribeFormState
    //   const result = langs.find(item => item.langCode === langCode)
    //   return result || {}
    // })
    return {
      modalData,
      ...toRefs(inject('initState'))
    }
  }
}
</script>

<style lang="scss" scoped></style>
